import './Main.scss';
import React, { Component } from 'react';
// import { observer,inject } from 'mobx-react';
// import TaskbarContainerUI from '../../view/TaskbarContainerUI/TaskbarContainerUI'
// import TaskbarUI from '../../view/TaskbarUI/TaskbarUI';
import Toolbar from '../../view/Toolbar/Toolbar';
import LayerTreeManager from '../../view/LayerTree/LayerTreeManager';
import context from '../../context';
import MapManager from '../../view/MapUI/MapManager';
import ToolkitManager from './../../toolkits/ToolkitManager';
export default class Main extends Component {
  constructor(props){
    super(props);
    this.state = {

    }
    this.layerManager = new LayerTreeManager({});
    context.mapManger = new MapManager();
    this.initLoad();
  }
  componentWillMount(){
  }
  componentDidMount(){
  }
  initLoad = ()=>{
  }
  getMapUI=()=>{
    return context.mapManger.getMapUIRender();
  }
  getToolKitUI=()=>{
    console.log(new ToolkitManager().init());
  }
  render() {
    return (
      <div className="app_main">
        {/* <div className='Taskbar'>
          <TaskbarUI></TaskbarUI>
        </div> */}
        {/* <div className='TaskbarContainer'>
          <TaskbarContainerUI/>
        </div> */}
        {this.layerManager.getUI()}
        <div className='map_layout'>
          {this.getMapUI()}
          {this.getToolKitUI()}
        </div>
        <Toolbar/>
      </div>
    )
  }
}
